var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.32c.723 0 1.32-.597 1.32-1.32 0-.745-.575-1.34-1.32-1.34s-1.32.617-1.32 1.34.597 1.32 1.32 1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.538 10h-7.076c-.434 0-.839-.158-1.145-.467a1.894 1.894 0 0 1-.49-.948c-.109-.504-.062-1.065.067-1.585H10C9 7 8 8 8 9v16c0 1 1 2 2 2h12c1 0 2-1 2-2V9c0-1-1-2-2-2h-.894c.129.52.176 1.081.067 1.585-.066.307-.205.66-.49.948a1.589 1.589 0 0 1-1.145.467zm-5.6 5.163c.07.105.106.295-.036.485-.278.391-.553.787-.827 1.182-.423.608-.846 1.217-1.283 1.812-.031.042-.063.084-.09.126a.566.566 0 0 1-.443.232c-.088 0-.177-.021-.23-.084a.604.604 0 0 1-.213-.274 61.627 61.627 0 0 0-.229-.47 22.8 22.8 0 0 1-.57-1.217C10 16.913 10 16.87 10 16.807c0-.105.035-.21.106-.274a.33.33 0 0 1 .446.042l.725.907c.297-.315.589-.636.881-.956.452-.496.903-.991 1.372-1.469.124-.105.302-.063.408.106zM16 16a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm0 5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm-6 1c0 1.106.894 2 2 2s2-.894 2-2-.894-2-2-2-2 .894-2 2z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.462 9h7.076C21 9 20 5 18 5h-4c-2 0-3 4-1.538 4z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardChecklist);
export default __webpack_public_path__ + "static/media/Clipboard_Checklist.78afe8b8ab7b1539cca8cb0a459cc5d1.svg";
export { ForwardRef as ReactComponent };